import React, { FunctionComponent } from 'react';
import './HiddenString.scss';

/**
 * The letter the blur is drawn over. The characters themselves are never legible — the style
 * renders them transparent behind a shadow — so they only have to occupy space.
 */
const FILLER_CHARACTER = 'n';

interface Props {
    /**
     * The value to hide. Only its shape is drawn: a blurred run of the same length, with its
     * spacing kept, so what stands in its place reads as the thing it replaced.
     */
    string?: string;
}

const HiddenString: FunctionComponent<Props> = (props: Props) => {
    const hidden = Array.from(props.string ?? '')
        .map((character) => (/\s/.test(character) ? character : FILLER_CHARACTER))
        .join('');

    return (
        <span>
            <span className="obfuscated-string">{hidden}</span>
        </span>
    );
};

export default HiddenString;
